/**
 * Base Breakpoint Tokens
 * Responsive design breakpoints (aligned with MUI defaults)
 */

export const baseBreakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
  },
} as const;

export type BaseBreakpoints = typeof baseBreakpoints;
